module.exports = __webpack_public_path__ + "static/media/RKBrowserw1044@2x.62522bc1.jpg";